/**
 * @fileoverview What the organization asked of one session: its note to the
 * instructor and the lesson plan it attached (O7).
 *
 * Rendered beside the session wherever the instructor meets it — the class's
 * sessions list, the composer, the written-up lesson — and nowhere a family
 * looks. Nothing here when the org left neither, so a session with no brief
 * takes no space.
 */

import { Icon } from "@/components/studio/primitives";

export default function SessionBrief({ session, className = "" }) {
  if (!session || (!session.prep_note && !session.plan)) return null;
  const id = session.occurrence_id || "session";
  return (
    <div className={`flex flex-col gap-1.5 ${className}`} data-testid={`session-brief-${id}`}>
      {session.prep_note && (
        <p
          className="whitespace-pre-line break-words font-sans text-[13px] leading-relaxed text-[var(--text-secondary)]"
          data-testid={`session-prep-note-${id}`}
        >
          <Icon name="info" size={13} className="mr-1.5 inline-block align-[-2px] text-[var(--text-tertiary)]" />
          {session.prep_note}
        </p>
      )}
      {session.plan && (
        <a
          href={session.plan.url}
          target="_blank"
          rel="noreferrer"
          className="inline-flex w-fit items-center gap-1.5 font-sans text-[13px] font-medium text-[var(--accent-yellow-text)] underline-offset-2 hover:underline"
          data-testid={`session-plan-${id}`}
          onClick={(e) => e.stopPropagation()}
        >
          <Icon name="paperclip" size={13} /> Lesson plan · {session.plan.filename}
        </a>
      )}
    </div>
  );
}
